import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { usePermissions } from '../../../contexts/PermissionsContext';

export default function ProductCategory({
  productCategories,
  handleOpenModal,
  pagination,
}) {
  const productCategorieData = Array.isArray(productCategories)
    ? productCategories
    : [];
  const { t } = useTranslation('MasterData');
  const [startIndex, setStartIndex] = useState(0);
  const { permissions } = usePermissions();
  useEffect(() => {
    setStartIndex(pagination.per_page * (pagination.current_page - 1) + 1);
  }, [pagination]);

  return (
    <div className="table-outer process-category-table">
      <table className="table">
        <thead>
          <tr className="t-heading">
            <th className="id">
              <h5>#</h5>
            </th>
            <th className="name">
              <h5>{t('PRODUCTCATEGORYNAME')}</h5>
            </th>
            <th className="code">
              <h5>{t('CODE')}</h5>
            </th>
            <th className="process-category">
              <h5>{t('PROCESSCATEGORY')}</h5>
            </th>
            <th className="process">
              <h5>{t('PROCESSLOCATION')}</h5>
            </th>
            <th className="action">
              {permissions?.MASTER_DATA_PRODUCT_CATEGORY?.edit_permission ===
                1 && <h5 className="pe-3">{t('ACTION')}</h5>}
            </th>
          </tr>
        </thead>
        <tbody>
          {productCategorieData.length === 0 ? (
            <tr>
              <td colSpan="100%" className="text-center py-4">
                {t('NORECODAVAILABLE')}
              </td>
            </tr>
          ) : (
            productCategorieData?.map((productCategories, index) => (
              <tr key={index}>
                <td className="id">
                  <h5>{index + startIndex}</h5>
                </td>
                <td className="name">
                  <h5>{productCategories.name}</h5>
                </td>
                <td className="code">
                  <h5>{productCategories.code}</h5>
                </td>
                <td className="process-category">
                  <h5>{productCategories.process_category?.name || ''}</h5>
                </td>
                <td className="process">
                  <h5>{productCategories.process_location?.name || ''}</h5>
                </td>
                <td className="action">
                  {permissions?.MASTER_DATA_PRODUCT_CATEGORY
                    ?.edit_permission === 1 && (
                    <>
                      <div className="">
                        <button
                          className="edit"
                          onClick={() =>
                            handleOpenModal('edit', productCategories)
                          }
                        >
                          <img src="images/green-edit.svg" alt="Edit" />
                        </button>
                        <button
                          className="delete"
                          onClick={() =>
                            handleOpenModal('delete', productCategories)
                          }
                        >
                          <img src="images/red-delete.svg" alt="" />
                        </button>
                      </div>
                    </>
                  )}
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
}
